// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__dTdTL","content":"styles_content__WQzqP","navigate":"styles_navigate__1nZP3"};